import React, { useEffect, useState } from "react";
import { ApiService } from "../services";
import { Add, Delete } from "@material-ui/icons";
import GButton from "../gComponents/gButton";
import { Formik, Form, Field, FieldArray } from "formik";
import FormikControl from "../formikComponents/formikControl";
import * as Yup from "yup";
import { useSnackbar } from "react-simple-snackbar";

const fieldStyle = {
  border: "0px",
  borderBottom: "1px solid #d2d2d2",
  background: "transparent",
};
export default function ProductVariantForm(props) {
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [openSnackbar] = useSnackbar();
  const [selectedProductVar, setSelectedProductVar] = useState({
    data: {},
    options: [],
  });

  const validationSchema = Yup.object({});

  useEffect(() => {
    console.log(JSON.stringify(props.selectedVariantType));
    setSelectedProductVar({
      data: props.selectedVariantType.data,
      options: props.selectedVariantType.options,
    });
  }, [props]);

  const initialValues = {
    options: props.selectedVariantType.options,
  };


  return (
    <div style={props.style}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ setFieldValue }) => (
          <Form>
            <FieldArray name="options">
              {(fieldArrayProps) => {
                const { push, remove, form } = fieldArrayProps;
                const { values } = form;
                const { options } = values;
                const handleAddVariant = (data, ind) => {
                 
                  setIsBtnDisabled(true);
                  values.options[ind].variant_id = selectedProductVar?.data.tile+"_"+ ind;
                  values.options[ind].product_variant_type_id = selectedProductVar?.data?.id; 
                  console.log(values.options[ind])
                  props.onVariantAdd(values.options[ind]);  
                };
               

                return (
                  <div>
                    <div
                      style={{
                        display: "inline-flex",
                        width: "100%",
                        padding: "0px 0 0 20px",
                        boxSizing: "border-box",
                      }}
                      className="arrayFields"
                    >
                      <label
                        style={{
                          width: props.isVarStockShow != "1" ? "37%" : "30%",
                        }}
                      >
                        Title
                      </label>
                      {props.selectedVariantType.data?.price_type == "0" ? (
                        ""
                      ) : (
                        <label
                          style={{
                            width: props.isVarStockShow != "1" ? "25%" : "20%",
                          }}
                        >
                          Price
                        </label>
                      )}
                      <label
                          style={{
                            width: "15%",
                          }}
                        >
                         Index
                        </label>
                      <label
                        style={{
                          width: props.isVarStockShow != "1" ? "25%" : "15%",
                        }}
                      >
                        Status
                      </label>
                      {props.isVarStockShow == "1" ? (
                        <label style={{ width: "30%" }}>Unlimited</label>
                      ) : (
                        ""
                      )}
                      <GButton
                        variant="linkable"
                        style={{width:'15%'}}
                        onClick={(e) => {
                          push({
                            title: "",
                            price:
                              props.selectedVariantType.data?.price_type == "0"
                                ? 0
                                : "",
                            status: "0",
                            index:0,
                            unlimited: 1,
                            stock: "0",
                          });
                          setIsBtnDisabled(false)
                        }}
                      >
                        <Add />
                      </GButton>
                    </div>
                    {options.map((o, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            display: "inline-flex",
                            width: "100%",
                            padding: "0px 0 0 15px",
                            boxSizing: "border-box",
                          }}
                          className="arrayFields"
                        >
                          <Field
                            type="text"
                            placeholder=""
                            name={`options[${index}].title`}
                            style={Object.assign({}, fieldStyle, {
                              width: "35%",
                            })}
                          />
                          {props.selectedVariantType.data?.price_type == "0" ? (
                            ""
                          ) : (
                            <Field
                              type="text"
                              placeholder=""
                              name={`options[${index}].price`}
                              style={Object.assign({}, fieldStyle, {
                                width: "20%",
                              })}
                            />
                          )}

<Field
                              type="text"
                              placeholder=""
                              name={`options[${index}].index`}
                              style={Object.assign({}, fieldStyle, {
                                width: "15%",
                              })}
                            />

                          <FormikControl
                            control="toggle"
                            isToggled={o.status === "1" ? 1 : 0}
                            name={`options[${index}].status`}
                            onToggle={() => {
                              let statusVal = o.status === "1" ? true : false;
                              statusVal = !statusVal;
                              statusVal = statusVal === true ? "1" : "0";
                              setFieldValue(
                                `options[${index}].status`,
                                statusVal
                              );
                            }}
                            style={{ width: "15%" }}
                          />

                          {props.isVarStockShow == "1" ? (
                            <div style={{ width: "30%" }}>
                              <FormikControl
                                control="toggle"
                                isToggled={
                                  o.unlimited === "1" ||
                                  o.unlimited === 1 ||
                                  o.unlimited === true
                                    ? 1
                                    : 0
                                }
                                name={`options[${index}].unlimited`}
                                onToggle={() => {
                                  let unlimitedVal =
                                    o.unlimited === "1" ? true : false;
                                  unlimitedVal = !unlimitedVal;
                                  unlimitedVal =
                                    unlimitedVal === true ? "1" : "0";
                                  setFieldValue(
                                    `options[${index}].unlimited`,
                                    unlimitedVal
                                  );
                                  console.log(!o.unlimited);
                                }}
                                style={{ width: "35%", padding: "4px 5px" }}
                              />

                              {props.isVarStockShow === "1" &&
                              !(o.unlimited === "1" || o.unlimited === 1) ? (
                                <Field
                                  type="text"
                                  placeholder=""
                                  name={`options[${index}].stock`}
                                  style={Object.assign({}, fieldStyle, {
                                    width: "40%",
                                    marginLeft: "10px",
                                  })}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            ""
                          )}

                          {!options[index].variant_id ? (
                            <GButton
                              disabled={isBtnDisabled}
                              variant="linkable"
                              onClick={(e) => {
                                handleAddVariant(options[index] , index);
                              }}
                              style={{ width: "150px" }}
                            >
                              Save
                            </GButton>
                          ) : ( 
                            <span style={{ display: "inline-flex",width:'25%' }}>
                             <GButton
                                variant="linkable"
                                onClick={(e) => { 
                                 props.onVariantEdit(options[index] , index);
                                }}
                              >
                                Update
                              </GButton>
                              <GButton
                                variant="linkable"
                                onClick={(e) => {
                                 remove(index);
                                 props.onVariantRemove(index);
                                }}
                              >
                                <Delete />
                              </GButton>
                              </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              }}
            </FieldArray>
          </Form>
        )}
      </Formik>
    </div>
  );
}
